$(document).ready(function () {
  var maxSelection = 3;
  var desktopQuery = window.matchMedia('(min-width: 768px)');

  function getCartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function showFormError($form, message) {
    var $wrapper = $form.find('.product-form__error-message-wrapper');
    var $message = $form.find('.product-form__error-message');

    if ($wrapper.length && $message.length) {
      $wrapper.removeAttr('hidden');
      $message.text(message);
    } else {
      alert(message);
    }
  }

  function hideFormError($form) {
    var $wrapper = $form.find('.product-form__error-message-wrapper');
    var $message = $form.find('.product-form__error-message');

    if ($wrapper.length && $message.length) {
      $wrapper.attr('hidden', 'hidden');
      $message.text('');
    }
  }

  function initAjaxCartSubmit($productForm) {
    if (!$productForm.length) return;

    $productForm.off('submit.customAjaxCart');

    $productForm.on('submit.customAjaxCart', function (e) {
      e.preventDefault();

      var $form = $(this);
      var $submitBtn = $form.find('[type="submit"]').first();
      var cart = getCartElement();

      if ($submitBtn.prop('disabled') || $submitBtn.attr('aria-disabled') === 'true') return;

      if (desktopQuery.matches) {
        var checkedCount = $('.custom-choose-products-wrapper input[type="checkbox"]:checked').length;

        if (checkedCount !== maxSelection) {
          showFormError($form, 'Please select 3 products before adding to cart.');
          return;
        }
      }

      hideFormError($form);

      $submitBtn.attr('aria-disabled', 'true');
      $submitBtn.addClass('loading');
      $form.find('.loading__spinner').removeClass('hidden');

      var formData = new FormData(this);

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map(function (section) {
            return section.id;
          })
        );
        formData.append('sections_url', window.location.pathname);
      } 

      fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json'
        },
        body: formData
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status || response.errors) {
            showFormError($form, response.description || response.message || response.errors || 'Something went wrong.');
            return;
          }

          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
          } else {
            fetch('/cart.js')
              .then(function (res) {
                return res.json();
              })
              .then(function () {
                if (cart && typeof cart.open === 'function') {
                  cart.open();
                }
              });
          }

          if (cart && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }
        })
        .catch(function (error) {
          console.error(error);
          showFormError($form, 'Something went wrong. Please try again.');
        })
        .finally(function () {
          $submitBtn.removeAttr('aria-disabled');
          $submitBtn.removeClass('loading');
          $form.find('.loading__spinner').addClass('hidden');
        });
    });
  }

  function initDesktopProductSelection() {
    var $wrapper = $('.custom-choose-products-wrapper');
    var $submitBtn = $('.product-form__submit');

    if (!$wrapper.length || !$submitBtn.length) return;

    $wrapper.off('change.desktopProductSelection');

    var $productForm = $submitBtn.closest('form[action*="/cart/add"]');

    if (!$productForm.length) {
      $productForm = $('form[action*="/cart/add"]').first();
    }

    initAjaxCartSubmit($productForm);

    function updateCartProperties($checkedBoxes) {
      if (!$productForm.length) return;

      $productForm.find('.custom-selected-product-property').remove();

      $('<input>', {
        type: 'hidden',
        class: 'custom-selected-product-property',
        name: 'properties[Product_type]',
        value: 'Anniversary'
      }).appendTo($productForm);

      var varids = [];

      $checkedBoxes.each(function (index) {
        var selectedIndex = index + 1;
        var $checkbox = $(this);
        var inputId = $checkbox.attr('id');

        var $label = $('label[for="' + inputId + '"]');

        var productTitle =
          $label.attr('data-product-title') ||
          $label.attr('data-title') ||
          $label.attr('data-handle') ||
          $.trim($label.text()) ||
          $checkbox.val();

        varids.push($label.attr('data-product-id'));  

        var productImage = $label.attr('data-product-image') || '';

        $('<input>', {
          type: 'hidden',
          class: 'custom-selected-product-property',
          name: 'properties[Product Title '+selectedIndex+']',
          value: productTitle
        }).appendTo($productForm);

        $('<input>', {
          type: 'hidden',
          class: 'custom-selected-product-property',
          name: 'properties[Product Image ' + selectedIndex + ']',
          value: productImage
        }).appendTo($productForm);
      });
      $('<input>', {
          type: 'hidden',
          class: 'custom-selected-product-property',
          name: 'properties[_Product Ids]',
          value: varids.join(',')
        }).appendTo($productForm);
    }

    function updateCheckboxState() {
      if (!desktopQuery.matches) return;

      var $checkboxes = $wrapper.find('input[type="checkbox"]');
      var $checkedBoxes = $wrapper.find('input[type="checkbox"]:checked');
      var checkedCount = $checkedBoxes.length;

      if (checkedCount === maxSelection) {
        $submitBtn.removeClass('disabled').prop('disabled', false).removeAttr('disabled');
      } else {
        $submitBtn.addClass('disabled').prop('disabled', true).attr('disabled', 'disabled');
      }

      var hasCheckedUniqueSelection = false;

      $checkedBoxes.each(function () {
        var inputId = $(this).attr('id');
        var $label = $('label[for="' + inputId + '"]');

        if ($label.attr('data-unique-selection') === 'true') {
          hasCheckedUniqueSelection = true;
          return false;
        }
      });

      $checkboxes.each(function () {
        var $checkbox = $(this);
        var inputId = $checkbox.attr('id');
        var $label = $('label[for="' + inputId + '"]');

        if (typeof $label.attr('data-original-disabled') === 'undefined') {
          $label.attr('data-original-disabled', $label.hasClass('disabled') ? 'true' : 'false');
        }

        var isOriginallyDisabled = $label.attr('data-original-disabled') === 'true';
        var isUniqueSelection = $label.attr('data-unique-selection') === 'true';
        var shouldDisableByLimit = !$checkbox.is(':checked') && checkedCount >= maxSelection;
        var shouldDisableByUniqueSelection = !$checkbox.is(':checked') && hasCheckedUniqueSelection && isUniqueSelection;
        var shouldDisable = isOriginallyDisabled || shouldDisableByLimit || shouldDisableByUniqueSelection;

        $checkbox.prop('disabled', shouldDisable);

        if (shouldDisable) {
          $label.addClass('disabled');
        } else {
          $label.removeClass('disabled');
        }
      });

      $('.custom-product-selected').each(function () {
        $(this).removeClass('active');
        $(this).find('img').attr('src', '').attr('alt', '');
      });

      $checkedBoxes.each(function (index) {
        var selectedIndex = index + 1;
        var $checkbox = $(this);
        var inputId = $checkbox.attr('id');

        var $label = $('label[for="' + inputId + '"]');

        var productImage = $label.attr('data-product-image');
        var productTitle =
          $label.attr('data-product-title') ||
          $label.attr('data-title') ||
          $label.attr('data-handle') ||
          $.trim($label.text()) ||
          '';

        var $selectedBox = $('.custom-product-selected[data-selected-item="' + selectedIndex + '"]');

        if ($selectedBox.length && productImage) {
          $selectedBox.addClass('active');

          $selectedBox.find('img')
            .attr('src', productImage)
            .attr('alt', productTitle);
        }
      });

      updateCartProperties($checkedBoxes);
    }

    $wrapper.on('change.desktopProductSelection', 'input[type="checkbox"]', function () {
      updateCheckboxState();
    });

    updateCheckboxState();
  }

  function resetDesktopSelectionIfMobile() {
    if (desktopQuery.matches) return;

    var $wrapper = $('.custom-choose-products-wrapper');
    var $submitBtn = $('.product-form__submit');
    var $productForm = $submitBtn.closest('form[action*="/cart/add"]');

    if (!$productForm.length) {
      $productForm = $('form[action*="/cart/add"]').first();
    }

    initAjaxCartSubmit($productForm);

    $wrapper.off('change.desktopProductSelection');

    $wrapper.find('input[type="checkbox"]').prop('disabled', false);

    $('.custom-product-selected').each(function () {
      $(this).removeClass('active');
      $(this).find('img').attr('src', '').attr('alt', '');
    });

    $productForm.find('.custom-selected-product-property').remove();
  }

  function handleScreenChange() {
    if (desktopQuery.matches) {
      initDesktopProductSelection();
    } else {
      resetDesktopSelectionIfMobile();
    }
  }

  handleScreenChange();

  $(window).on('resize', function () {
    handleScreenChange();
  });
}); 